import React from 'react';
import { CheckIcon } from 'lucide-react';

interface AssessmentStepsProps {
  currentStep: number;
}

const steps = [
  { number: 1, label: 'Role Details' },
  { number: 2, label: 'Assessment Type' },
  { number: 3, label: 'Skills' },
  { number: 4, label: 'Questions' },
  { number: 5, label: 'Interviewer Settings' },
  { number: 6, label: 'Complete' },
];

const AssessmentSteps: React.FC<AssessmentStepsProps> = ({ currentStep }) => {
  return (
    <div className="w-full">
      <div className="flex items-center justify-center">
        <div className="relative w-full max-w-3xl flex items-center justify-between">
          {/* Connecting Lines Layer */}
          <div className="absolute top-5 left-0 right-0 w-full flex items-center justify-center z-0">
            <div className="w-full flex justify-between px-5">
              {steps.slice(0, -1).map((_, index) => (
                <div
                  key={`line-${index}`}
                  className={`h-[2px] transition-all duration-500 ${
                    currentStep > index + 1 || (currentStep > index && currentStep === index + 2)
                      ? 'bg-[#9b87f5]'
                      : 'bg-[#1A1F2C]/20'
                  }`}
                  style={{ width: `calc(${100 / (steps.length - 1)}% - 20px)` }}
                />
              ))}
            </div>
          </div>

          {/* Steps Layer */}
          {steps.map((step, index) => {
            const isActive = currentStep === step.number;
            const isCompleted = currentStep > step.number;

            return (
              <div key={step.number} className="flex flex-col items-center z-10">
                <div 
                  className={`w-10 h-10 rounded-full flex items-center justify-center border-2 transition-all duration-300 ${
                    isCompleted 
                      ? 'bg-[#9b87f5] border-[#9b87f5] text-white shadow-md' 
                      : isActive 
                        ? 'bg-white border-[#9b87f5] text-[#1A1F2C] shadow-sm' 
                        : 'bg-white border-[#1A1F2C]/30 text-[#1A1F2C]/60'
                  }`}
                >
                  {isCompleted ? (
                    <CheckIcon className="h-5 w-5" />
                  ) : (
                    <span className="text-inherit">{step.number}</span>
                  )}
                </div>
                <span className={`mt-2 text-xs text-center font-medium ${isActive || isCompleted ? 'text-[#1A1F2C]' : 'text-[#1A1F2C]/60'}`}>
                  {step.label}
                </span>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default AssessmentSteps;
